const zh = {
    menu: {
        unConfig: '未配置地址',
    },
    tabName: {
        dashboard: '首页',
    },
    button: {
        search: '查询',
        reset: '重置',
        add: '新增',
        edit: '修改',
        delete: '删除',
        confirm: '确定',
        save: '保存',
        cancel: '取消',
        close: '关闭',
    },
    tip: {
        tip: '提示',
        success: '操作成功',
        fail: '操作失败',
        delTip: '是否继续删除？',
    },
    login: {
        userName: '用户名',
        account: '账户',
        password: '密码',
        btn: '登录',
        logout: '退出',
    },
}
export default zh;


// WEBPACK FOOTER //
// ./src/i18n/config/zh.js